import React from 'react';
import { CnChart, echarts } from '@/components/cn-chart';
import { CnStatisticMiniChartProps } from './types';

/**
 * 指标卡 侧边栏组件
 * @param {*} props
 * @returns
 */
function CnStatisticMiniChart({
  data,
  width,
  height = '34px',
}: CnStatisticMiniChartProps) {
  return (
    <div style={{ display: 'flex' }}>
      <CnChart
        containerStyle={{
          // 从父容器继承宽度，如果父容器无宽度会导致图表容器无宽度，需要配置width。
          ...(width ? { width } : null),
          height,
          paddingTop: '10px',
          flex: 'none',
        }}
        {...{
          // 数据集配置：https://echarts.apache.org/zh/option.html#dataset
          dataset: {
            dimensions: [{ name: 'x' }, { name: 'y', displayName: '数值' }],
            source: data,
          },
          // tooltip配置：https://echarts.apache.org/zh/option.html#grid.tooltip
          tooltip: {
            trigger: 'axis',
          },
          // X轴配置：https://echarts.apache.org/zh/option.html#xAxis
          xAxis: {
            type: 'category',
            show: false,
            boundaryGap: false,
          },
          // Y轴配置：https://echarts.apache.org/zh/option.html#yAxis
          yAxis: {
            show: false,
          },
          // 网格配置：https://echarts.apache.org/zh/option.html#grid
          grid: {
            show: false,
            top: 2,
            left: '0',
            right: '0',
            bottom: '0',
            containLabel: false,
          },
          // 柱状图配置：https://echarts.apache.org/zh/option.html#series-bar
          series: [
            {
              type: 'line',
              symbol: 'none',
              areaStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {
                      offset: 0,
                      color: 'rgba(128, 128, 255, 0.8)', // 渐变起始颜色
                    },
                    {
                      offset: 1,
                      color: 'rgba(128, 128, 255, 0.2)', // 渐变结束颜色
                    },
                  ]),
                },
              },
              lineStyle: {
                width: 1,
              },
              smooth: true,
            },
          ],
        }}
      />
    </div>
  );
}
export { CnStatisticMiniChart };
export type { CnStatisticMiniChartProps };
